export const getPath = (path: string) => {
	return `${process.env.app.protocol}://${process.env.app.host}${path}`;
};
